import { useTransportQuery } from "@/transport"

import type { SystemStatusTransportState } from "../types"

export function useSystemStatusTransport(): SystemStatusTransportState {
  const query = useTransportQuery({
    operation: "getSystemStatus",
    options: {
      refetchInterval: 60_000,
    },
  })
  const isLoading = query.isLoading || (!query.data && !query.error)

  return {
    data: query.data,
    error: query.error,
    isLoading,
    isRefreshing: query.isFetching && !isLoading,
    refresh: async () => {
      await query.refetch()
    },
  }
}
